import React, { useState, useEffect } from 'react';
import './styles.scss';  // Import your Sass styles

function App() {
  const [quoteText, setQuoteText] = useState('GENERATING');
  const [quoteAuthor, setQuoteAuthor] = useState('');
  const [quoteTags, setQuoteTags] = useState('');

  // Function to fetch a new quote
  const fetchNewQuote = async () => {
    try {
      const url = 'https://random-quote-generator2.p.rapidapi.com/randomQuote';
      const options = {
        method: 'GET',
        headers: {
          'x-rapidapi-key': '274a3e529amsh3bc2c03ae954c12p147fe0jsn1d668f49e545', 
          'x-rapidapi-host': 'random-quote-generator2.p.rapidapi.com'
        }
      };
  
      const response = await fetch(url, options);
      const data = await response.json();
  
      console.log('API response:', data);

      if (data.message) { // Checks for rate limit error
        setQuoteText("TOO MANY REQUESTS, RETURN TOMORROW");  
        setQuoteAuthor("DAILY LIMIT REACHED");
        document.getElementById("new-quote").disabled = true;
        document.getElementById("new-quote").style.cursor = "not-allowed";
        document.getElementById("tweet-quote").style.pointerEvents = "none";
        return;
      }

      if (data && Array.isArray(data) && data.length > 0) {
        const quoteData = data[0];  // Access the first item in the array
  
        // Check if the quote length is <= 50, otherwise fetch a new one
        if (quoteData.Quote && quoteData.Quote.length <= 150) {
          setQuoteText(quoteData.Quote);  // Set the quote if it's <= 150 characters
          setQuoteAuthor(quoteData.Author || 'Unknown');
          setQuoteTags(quoteData.Tags || '');
        } else {
          // If the quote exceeds 50 characters, fetch a new one
          console.log(`Quote too long: ${quoteData.Quote.length} characters. Fetching a new quote.`);
          fetchNewQuote();
        }
      } else {
        console.error('No valid quote found in the API response');
      }
    } catch (error) {
      console.error('Failed to fetch the quote:', error);
    }
  };

  // Call fetchNewQuote on the first render
  useEffect(() => {
    fetchNewQuote();  // Fetch a quote when the app loads
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Process the tags for the tweet
  const tags = quoteTags.replace(/-/g, "").split(", ");
  const tweetUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(
    `"${quoteText}" - ${quoteAuthor}`
  )}&hashtags=${tags.join(',')}`;

  return (
    <div className="App">
      <section id="quote-info">
        <p id="text" className="text-center">{quoteText}</p>
        <p id="author"> - <span id="name">{quoteAuthor}</span></p>
      </section>

      <section id="clickables">
        <a id="tweet-quote" href={tweetUrl} target="_blank" rel="noreferrer">
          <i className="fab fa-twitter"></i> 
        </a>
        <button
          id="new-quote"
          onClick={fetchNewQuote}  // Fetch a new quote
        >
          New quote
        </button>
      </section>
    </div>
  );
}

export default App;
